var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundIconInProcessing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 22.586,
    fill: "#F5A623"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.664 13.205a.82.82 0 0 1 .82-.82h18.032a.82.82 0 0 1 0 1.64h-.82c-.05 1.37-.246 3.298-.905 4.564-.167.322-.303.588-.417.812-.28.55-.434.85-.621 1.127-.225.333-.5.632-1.106 1.291l-.332.362c-2.198 2.398-1.88 4.472 0 6.965 1.573 2.086 1.645 2.328 2.266 4.414l.21.701c.24.792.46 1.843.623 2.714h1.102a.82.82 0 0 1 0 1.64H16.484a.82.82 0 0 1 0-1.64h1.042c.136-.871.33-1.922.568-2.714.13-.427.234-.792.325-1.11.5-1.74.611-2.13 2.162-4.005 2.043-2.47 2.383-4.543 0-6.965-1.404-1.428-1.414-1.448-1.952-2.535a56.438 56.438 0 0 0-.534-1.057c-.659-1.266-.816-3.194-.834-4.564h-.777a.82.82 0 0 1-.82-.82Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundIconInProcessing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roundIconInProcessing.b407aaff32aa828d2246df4432273066.svg";